import React from 'react';
import { Route, Routes as Switch } from 'react-router-dom';
import PageLayout from 'components/page-layout';
import { ROUTES } from 'constants/app-constant';

const Routes = () => {
	return (
		<Switch>
			<Route element={<PageLayout />}>
				{ROUTES.map(({ route, Component }, index) => {
					return <Route key={index} exact path={route} element={<Component />} />;
				})}
				<Route exact path="*" element={<div>No route</div>} />
			</Route>
			{/* <Route exact path="/login" element={<Login />} /> */}
			{/* <Route exact path="/register" element={<Register />} />
				<Route exact path="/organization" element={<OrganizationList />} /> */}
		</Switch>
	);
};

export default Routes;
